import React from "react";
import ReactOwlCarousel from "react-owl-carousel";
import VideoItems from "../main/videoitems";
// import VidItem from "../main/videoitems";
// import { Swiper, SwiperSlide } from "swiper/react";
import "./description.css";

function Description(props) {
  return (
    <div className="description">
      {!props.videosOpen && <p>{props.description}</p>}
      {/* <div className="desc__vidcont"> */}
      {/* <VidItem /> */}
      {/* </div> */}
      {props.videosOpen && <VideoItems desktop={props.videosOpen} />}
    </div>
  );
}
export default Description;
